import "./frontend/know-how-filter.js";
import "./frontend/navigation.js";

( () => {

    var $ = require( "jquery" );

    const site = {

        bootstrap: () => {           

        }

    };

    $(document).ready( site.bootstrap )

} )();